import React, { useState } from 'react'
import { dateCol, strCol } from '@integec/grid-tools/lib/cols'
import CommonScreen from '../admin/component/CommonScreen'
import { DatePicker, Button, Input } from 'antd'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import * as api from '../api/pgads'
import { Label } from 'core/screen-util'

const title = 'Peak Avail. Holiday'

const Holiday = () => {
  const [insertEvent, setInsertEvent] = useState(false)

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '100px 150px 100px 300px auto auto auto',
        gap: 5,
      }}
    >
      <Label>Holiday Date :</Label>
      <DatePicker
        allowClear={false}
        format="MM/DD/YYYY"
        value={insertData.holidayDateMom}
        onChange={date => {
          setInsertData({
            ...insertData,
            holidayDateMom: date,
            holidayDate: date.format('YYYY-MM-DD'),
            year: date.year(),
          })
        }}
      />
      <Label>Holiday :</Label>
      <Input
        value={insertData.holiday}
        onChange={e =>
          setInsertData({ ...insertData, holiday: e.target.value })
        }
        maxLength={15}
      />
      <Button
        type="primary"
        style={{ marginLeft: '50px' }}
        onClick={() => onAdd(true)}
      >
        Add
      </Button>
      <Button
        type="primary"
        style={{ marginLeft: '50px' }}
        onClick={() => onAdd(false)}
      >
        Add & Hide
      </Button>
      <Button type="danger" style={{ marginLeft: '50px' }} onClick={onCancel}>
        Cancel
      </Button>
    </div>
  )

  return (
    <CommonScreen
      withUnitSelection={false}
      isAdminScreen
      title={title}
      header={HolidayHeaders}
      saveTask={api.postHolidayMgmtInfo}
      retrieveTask={api.getHolidayMgmtInfo}
      deleteTask={api.deleteHolidayMgmtInfo}
      autoRetrieve
      sortOptions={HolidayHeaders}
      totalWidth={680}
      insertCompHeight={50}
      insertComp={insertEvent && insertComp}
      defaultInsertData={{ company: 'ALL' }}
      onInsertEvent={b => setInsertEvent(b)}
      autoFixColByKey={false}
    />
  )
}

export default Holiday

export const HolidayHeaders = [
  dateCol({
    ident: 'holidayDate',
    display: 'Holiday Date',
    isKey: true,
  }),
  strCol({
    ident: 'holiday',
    display: 'Holiday',
    width: 250,
    ellipsis: true,
  }),
  modifierCol,
  modifiedDateCol,
]
